import { useUserStore } from '@/store/userStore'
export default async (context) => {
  const userStore = useUserStore(context.app.pinia)
  userStore.setHost()

  const promises = [
    context.store.dispatch('setting/get'),
    context.store.dispatch('filters/get'),
  ]

  await Promise.all(promises)
}
